import { jsx as t } from "react/jsx-runtime";
import { FileItemCompact as i } from "./file-item-compact.mjs";
import { FileItemWide as r } from "./file-item-wide.mjs";
const n = (e) => {
  const { wide: m } = e;
  return m ? /* @__PURE__ */ t(r, { ...e }) : /* @__PURE__ */ t(i, { ...e });
};
export {
  n as FileItem
};
